import React, { useState } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';

import { Box } from '@mui/material';

import './Main.css';

import lobJSON from '../assets/lobBranding.json';
import { ToastBar } from '../components/toastBar/index';
import LocalStorageService from '../services/localStorage';
import { BCBSAL_ORG_ID } from '../shared/const';

import Breadcrumbs from './components/Breadcrumbs';
import Footer from './components/Footer';
import Header from './components/Header';

const localStorageService = LocalStorageService.getService();

const Main = (props) => {
  const { orgId } = useParams();
  const [searchParams] = useSearchParams();

  const lob = searchParams.get('lob');

  const [loading, setLoading] = useState(true);
  const [brandingInfo, setBrandingInfo] = useState(null);
  React.useEffect(() => {
    setLoading(true);

    // This needs to work for AL only, as we need to show branding based on LOB for AL
    if (lobJSON && orgId && lob && orgId === '938125692074') {
      // Convert to lowercase array for comparison
      let lobArray = lob.split(',').map((l) => l.trim().toLowerCase());

      // Priority logic
      let filterLob;
      if (lobArray.includes('bcbs al')) {
        filterLob = lobJSON[orgId].find(() => lobArray.includes('bcbs al'));
      } else {
        // Choose the first matching LOB in lobList that appears in lobArray
        filterLob = lobJSON[orgId].find((l) =>
          lobArray.includes(l?.title.toLowerCase())
        );
      }

      if (typeof filterLob === 'undefined') {
        lobArray = ['bcbs al'];
        filterLob = lobJSON[orgId].find(() => lobArray.includes('bcbs al'));
      }

      setBrandingInfo(filterLob);
      localStorageService.setBrandingInfo(JSON.stringify(filterLob));
      setLoading(false);
    }
    // Branding from tenant Configuration
    else {
      if (Object.keys(lobJSON) && Object.keys(lobJSON).length > 0) {
        let lobBranding = lobJSON[Object.keys(lobJSON)[0]].filter(
          (i) => i.title.toLowerCase() === 'default'
        );

        setBrandingInfo(lobBranding[0]);

        localStorageService.setBrandingInfo(JSON.stringify(lobBranding[0]));

        setLoading(false);
      }
    }
  }, [orgId, lob]);

  if (loading || !brandingInfo) {
    return <div>Loading...</div>;
  }

  return (
    <Box component="section" className="mainLayoutBox">
      <ToastBar />
      <Header isQuestionnaire={props?.isQuestionnaire} />
      <Breadcrumbs />
      <main>
        <Outlet />
      </main>
      {orgId == BCBSAL_ORG_ID && <Footer />}
    </Box>
  );
};

Main.propTypes = {
  isQuestionnaire: false,
};

export default Main;
